export default function renderMultipleMetaobjects() {
  const metaObjModule = Array.from(document.querySelectorAll('.section-story'));
  for (let i = 0; i < metaObjModule.length; i++) {
    const moduleParent = metaObjModule[i],
      moduleChildren = moduleParent.querySelectorAll('.story');

    // if metaobject entries count is less than theme settings modules count
    if (
      metaObjModule.length > moduleChildren.length &&
      moduleChildren.length <= i
    ) {
      moduleParent.remove();
    } else {
      // populate metaobject entries over corresponding theme settings setup
      const moduleChild = moduleChildren[i];
      if (moduleChild) {
        moduleParent.innerHTML = '';
        moduleParent.append(moduleChild);
      }
    }
  }
}
